import Cookies from "js-cookie";

export const handleSetPassword = () => {
  const gonState = window?.gon?.state;
  if (gonState?.analyticsData) {
    gonState.analyticsData = { source: "nav" };
  }
  if (gonState?.triggerScenario) {
    gonState.triggerScenario("SetPassword");
  }
  return false;
};

export const onComparablesReportsClick = () => {
  const gonState = window?.gon?.state;
  if (typeof gonState === "object" && gonState !== null) {
    gonState.analyticsData = {
      source: "comparables_report"
    };
    if (typeof gonState.triggerScenario === "function") {
      gonState.triggerScenario("EmailCapture", {
        redirectTo: "/my/comparables"
      });
    }
  }
};

export const onSearchTab = (searchTab, link) => {
  Cookies.set("last_search_tab", searchTab, {
    expires: 10 * 365,
    path: "/"
  });

  if (window?.location && link) {
    window.location.href = link;
  }
};
